/* ==========================================================================
   Redesign-Megamenü (Desktop): Panel bleibt offen, bis
   - ein anderer Hauptmenüpunkt gehovert wird,
   - die Maus den Header nach oben verlässt oder
   - die Maus das Panel nach unten verlässt.
   Expanse selbst öffnet nur per :hover auf dem Menüpunkt (theme.css.liquid).
   ========================================================================== */

(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var header = document.getElementById('SiteHeader');
  if (!header || !header.closest('.ds-header-v2')) return;

  var holdClass = 'ds-mega-hold';
  var topItems = header.querySelectorAll('.site-navigation > .site-nav__item');
  var openItem = null;

  function close() {
    if (!openItem) return;
    openItem.classList.remove(holdClass);
    openItem = null;
  }

  window.matchMedia('(min-width: 1440px)').addEventListener('change', close);

  topItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (item === openItem) return;
      close();
      if (item.querySelector('.ds-megamenu')) {
        item.classList.add(holdClass);
        openItem = item;
      }
    });
  });

  // Panel liegt im Header – verlassen heißt: nach oben raus oder unter dem Panel
  header.addEventListener('mouseleave', close);

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') close();
  });

  document.addEventListener('click', function (evt) {
    if (openItem && !openItem.contains(evt.target)) close();
  });
})();
